<template>
    <div>
        <AudioCheck />
        <VideoCheck />
    </div>
</template>

<script>
import AudioCheck from './AudioCheck';
import VideoCheck from './VideoCheck';

export default {
    name: 'MediaDeviceCheck',
    components: {
        AudioCheck,
        VideoCheck,
    },
    mounted: async function() {
        await this.$store.commit('devices/setDevices');
    }
};
</script>
<style scoped></style>
